<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
         <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-large
        rounded="sm"
      >
      <!-- Register v1 -->
      <b-card class="mb-0 text-center">
        <b-img @click="get_pt_session" v-if="session.logo" :src="session.logo" style="max-width:70%;"></b-img>
        <div v-if="success=== false">
          <h3>為你的體驗評分</h3>
        <div style="font-weight: bold;">
            課堂日期: {{ session.start }}<br>
            教練名稱: {{ session.display_name }}<br>
            上堂地點: {{ session.center_name }}
        </div>
      <b-form-rating
      no-border
      class="mt-5"
      v-model="rating"
      size="lg"
      variant="warning"
    />
    
    <b-avatar
      size="70px"
      class="m-2"
      variant="light-warning"
      :text="rating_text"
    />

    <b-button variant="success" block @click="submit_rate">提交 Submit</b-button>
    </div>
    <div v-if="success=== true">
        <h3>評分成功<br>非常感謝多謝你的評分</h3>
    </div>
      </b-card>
    <!-- /Register v1 -->
     </b-overlay>
    </div>
  </div>

</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardTitle, BCardText, BForm,BOverlay,BAvatar,BImg,
  BButton, BFormInput, BFormGroup, BInputGroup, BInputGroupAppend, BFormCheckbox,BFormRating
} from 'bootstrap-vue'
import router from '@/router'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    VuexyLogo,
    BFormRating,
    BCard,
    BOverlay,
    BAvatar,
    BLink,
    BCardTitle,
    BImg,
    router,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      rating: 0,
      success: false,
      session: {
        logo: null
      }
    }
  },
   computed: {
        rating_text() {
            if (this.rating < 1) { 
                return ' '
            } else {
            return this.rating.toString()
            }
        },
    },
  created() {
   this.get_pt_session()
  },
  methods: {
     get_pt_session() {
      this.loading = true
        this.$http.get(process.env.VUE_APP_API_BASE+`/../perfit/pt-session/`+ router.currentRoute.params.id + `/`)
          .then(res => {
            if (res.data.result === true) {
              this.loading = false
               this.session = res.data.session
            } else {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Error',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: res.data.result.message,
                },
              })
            }
          })
    },
    submit_rate() {
      this.loading = true
        this.$http.post(process.env.VUE_APP_API_BASE+`/../perfit/pt-session/`+ router.currentRoute.params.id + `/`, {
          rating:this.rating
        })
          .then(res => {
            if (res.data.result === true) {
              this.loading = false
              this.success = true
             
            } else {
              this.loading = false
              this.$toast({
                component: ToastificationContent,
                position: 'top-center',
                props: {
                  title: 'Error',
                  icon: 'XIcon',
                  variant: 'danger',
                  text: res.data.result.message,
                },
              })
            }
          })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.form-control-lg {
    font-size:3rem !important;
}
</style>
